import React from 'react';
import {ReactComponent as Menu} from '../../assets/icons/menu.svg';
import {useMobileNav} from './MobileNavProvider';

const Header = ({title, children}) => {
    const {openMenu} = useMobileNav();

    const handleOpenMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        openMenu();
    };

    return (
        <header className="rest-panel-header">
            <button
                type="button"
                className="rest-panel-header__menu lg:hidden"
                onClick={handleOpenMenu}
                aria-label="باز کردن منو"
                aria-haspopup="dialog"
            >
                <Menu/>
                <span>منو</span>
            </button>

            <h1 className="rest-panel-header__title">{title}</h1>

            {children && (
                <div className="rest-panel-header__actions">
                    {children}
                </div>
            )}
        </header>
    );
};

export default Header;
